import { PayJustNowComponent } from './components/channel-virtual-version-two/portal/payments/promotions/pay-just-now/pay-just-now.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PortalComponent } from './components/portal/portal.component';
import { WalletComponent } from './components/afripay/wallet/wallet.component';
import { ErrorHandlingComponent } from './components/error-handling/error-handling.component';
import { SecureEftTransactionComponent } from './components/secure-eft/transaction/transaction.component';
import { CardComponent } from './components/card/card.component';
import { MobicredComponent } from './components/mobicred/mobicred/mobicred.component';
import { EftComponent } from './components/secure-eft/base/eft.component';
import { OttVoucherComponent } from './components/ott-voucher/ott-voucher.component';
import { VoucherInputComponent } from './components/ott-voucher/voucher-input/voucher-input.component';
import { VoucherProcessingComponent } from './components/ott-voucher/voucher-processing/voucher-processing.component';
import { MobicredLoginComponent } from './components/mobicred/mobicred-login/mobicred-login.component';
import { MobicredOtpComponent } from './components/mobicred/mobicred-otp/mobicred-otp.component';
import { AfripayComponent } from './components/afripay/afripay.component';
// import {ConfirmationComponent} from './components/afripay/confirmation/confirmation.component';
import { ProcessingComponent } from './components/afripay/processing/processing.component';
import { TransactionStatusComponent } from './components/transaction-status/transaction-status.component';
import { CardAddComponent } from './components/card/add/add.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { PaymentsComponent } from './components/payments/payments.component';
import { QuicklinkStrategy } from 'ngx-quicklink';
import { TdsComponent } from './components/card/tds/tds.component';
import { ZapperComponent } from './components/zapper/zapper.component';
import { MasterPassComponent } from './components/master-pass/master-pass.component';
import { ValidateComponent } from './components/master-pass/validate/validate.component';
import { SwitchpayComponent } from './components/switchpay/switchpay.component';
import {SwitchpayCallbackComponent} from './components/switchpay/callback/switchpay-callback.component';
import { ClickToPayComponent } from './components/click-to-pay/click-to-pay.component';
import { VisaClickToPayComponent } from './components/click-to-pay/visa-click-to-pay/visa-click-to-pay.component';
import { AdumoeftComponent } from './components/adumoeft/initiate/adumoeft.component';
import { AdumoeftCallbackComponent } from './components/adumoeft/callback/adumoeft-callback.component';
import { OzowComponent } from './components/ozow/initiate/ozow.component';
import {OzowCallbackComponent} from './components/ozow/callback/ozow-callback.component';
import {InstalmentComponent} from './components/card/instalment/instalment.component';
import {ConfirmSelectionComponent} from './components/card/confirm-selection/confirm-selection.component';
import { ChannelPaymentPageComponent } from './components/channel-payment-page/channel-payment-page.component';
import { ChannelVirtualComponent } from './components/channel-virtual/channel-virtual.component';
import { ChannelVirtualVersionTwoComponent } from './components/channel-virtual-version-two/channel-virtual-version-two.component';
import {PortalComponent as PortalV2Component} from './components/channel-virtual-version-two/portal/portal.component';
import {PaymentsComponent as PaymentsV2Component} from './components/channel-virtual-version-two/portal/payments/payments.component';
import {EftComponent as EftV2Component} from './components/channel-virtual-version-two/eft/eft.component';
import {SecureEftTransactionComponent as SecureEftTransactionV2Component} from './components/channel-virtual-version-two/eft/secure-eft-transaction/secure-eft-transaction.component';
import {MobicredComponent as MobicredV2Component} from './components/channel-virtual-version-two/mobicred/mobicred.component';
import {MobicredLoginComponent as MobicredLoginV2Component} from './components/channel-virtual-version-two/mobicred/mobicred-login/mobicred-login.component';
import {MobicredOtpComponent as MobicredOtpV2Component} from './components/channel-virtual-version-two/mobicred/mobicred-otp/mobicred-otp.component';
import {LifestyleRewardsComponent as LifestyleRewardsV2Component} from './components/channel-virtual-version-two/lifestyle-rewards/lifestyle-rewards.component';
import {LifestyleRewardsLoginComponent as LifestyleRewardsLoginV2Component} from './components/channel-virtual-version-two/lifestyle-rewards/lifestyle-rewards-login/lifestyle-rewards-login.component';
import {OttVoucherComponent as OttVoucherV2Component} from './components/channel-virtual-version-two/ott-voucher/ott-voucher.component';
import {VoucherInputComponent as VoucherInputV2Component} from './components/channel-virtual-version-two/ott-voucher/voucher-input/voucher-input.component';
import {VoucherProcessingComponent as VoucherProcessingV2Component} from './components/channel-virtual-version-two/ott-voucher/voucher-processing/voucher-processing.component';
import {CardComponent as CardV2Component} from './components/channel-virtual-version-two/card/card.component';
import {CardAddComponent as CardAddV2Component} from './components/channel-virtual-version-two/card/card-add/card-add.component';
import {ConfirmSelectionComponent as ConfirmSelectionV2Component} from './components/channel-virtual-version-two/card/confirm-selection/confirm-selection.component';
import {InstalmentComponent as InstalmentV2Component} from './components/channel-virtual-version-two/card/instalment/instalment.component';
import {TdsComponent as TdsV2Component} from './components/channel-virtual-version-two/card/tds/tds.component';
import {MasterpassComponent as MasterpassV2Component} from './components/channel-virtual-version-two/masterpass/masterpass.component';
import {ValidateComponent as ValidateV2Component} from './components/channel-virtual-version-two/masterpass/validate/validate.component';
import {SwitchpayComponent as SwitchpayV2Component} from './components/channel-virtual-version-two/switchpay/switchpay.component';
import {SwitchpayCallbackComponent as SwitchpayCallbackV2Component} from './components/channel-virtual-version-two/switchpay/switchpay-callback/switchpay-callback.component';
import {ZapperComponent as ZapperV2Component} from './components/channel-virtual-version-two/zapper/zapper.component';
import {OzowComponent as OzowV2Component} from './components/channel-virtual-version-two/ozow/ozow.component';
import {OzowCallbackComponent as OzowCallbackV2Component} from './components/channel-virtual-version-two/ozow/ozow-callback/ozow-callback.component';
import {ErrorHandlingComponent as ErrorHandlingV2Component} from './components/channel-virtual-version-two/error-handling/error-handling.component';
import {NotFoundComponent as NotFoundV2Component} from './components/channel-virtual-version-two/not-found/not-found.component';
import { TransationStatusComponent as TransationStatusV2Component } from './components/channel-virtual-version-two/transation-status/transation-status.component';
import { PayJustNowComponent as PayJustNowV2Component} from './components/channel-virtual-version-two/pay-just-now/pay-just-now.component';
import { AuthPaymentMethodGuard } from './guard/auth-payment-method/auth-payment-method.guard';
import {
  GooglePaySelectedComponent
} from "./components/channel-virtual-version-two/card/google-pay-selected/google-pay-selected.component";
import {
  ApplePaySelectedComponent
} from "./components/channel-virtual-version-two/card/apple-pay-selected/apple-pay-selected.component";
import { CallbackComponent as PayJustNowCallbackV2Component } from './components/channel-virtual-version-two/pay-just-now/callback/callback.component';

const routes: Routes = [
  {
    path: 'payment-page',
    component: ChannelPaymentPageComponent
  },
  {
    path:'virtual-v2',
    component:ChannelVirtualVersionTwoComponent,
    children:[
      {
        path:'',
        component:PortalV2Component
      },
      {
        path:'eft',
        children:[
          {
            path:'',
            component:EftV2Component,
            children:[
              {
                path:'transaction',
                component:SecureEftTransactionV2Component
              }
            ]
          }
        ]
      },
      {
        path:'mobicred',
        component:MobicredV2Component,
        children:[
          {
            path:'login',
            component:MobicredLoginV2Component
          },
          {
            path:'otp',
            component:MobicredOtpV2Component
          },
          {
            path:'**',
            redirectTo:'login'
          }
        ]
      },
      {
        path:'lifestyle_rewards',
        component:LifestyleRewardsV2Component,
        children:[
          {
            path:'login',
            component:LifestyleRewardsLoginV2Component
          },
          {
            path:'**',
            redirectTo:'login'
          }
        ]
      },
      {
        path:'ott_voucher',
        component:OttVoucherV2Component,
        children:[
          {
            path:'input',
            component:VoucherInputV2Component
          },
          {
            path:'processing',
            component:VoucherProcessingV2Component
          },
          {
            path:'**',
            redirectTo:'input'
          }
        ]
      },
      {
        path:'card',
        children:[
          {
            path:'',
            component:CardV2Component,
            children:[
              {
                path:'add',
                component:CardAddV2Component
              },
              {
                path:'tds',
                component:TdsV2Component
              },
              {
                path:'instalment',
                component:InstalmentV2Component
              },
              {
                path:'confirm-selection/:vPlanId',
                component:ConfirmSelectionV2Component
              },
              {
                path:'google-pay',
                component: GooglePaySelectedComponent
              },
              {
                path:'apple-pay',
                component: ApplePaySelectedComponent
              }
            ]
          }
        ]
      },
      {
        path:'master_pass',
        children:[
          {
            path:'',
            component:MasterpassV2Component
          },
          {
            path:'validate',
            component:ValidateV2Component
          }
        ]
      },
      {
        path:'switchpay',
        children:[
          {
            path:'',
            component:SwitchpayV2Component
          },
          {
            path:'callback',
            component:SwitchpayCallbackV2Component
          }
        ]
      },
      {
        path:'pay-just-now',
        children: [
          {
            path:'',
            component:PayJustNowV2Component
          },
          {
            path:'callback',
            component: PayJustNowCallbackV2Component
          }
        ]
      },
      {
        path:'zapper',
        children:[
          {
            path:'',
            component:ZapperV2Component
          }
        ]
      },
      {
        path:'ozow',
        children:[
          {
            path:'',
            component:OzowV2Component
          },
          {
            path:'status',
            component:OzowCallbackV2Component
          }
        ]
      },
      {
        path:'error',
        component: ErrorHandlingV2Component
      },
      {
        path:'transaction-status',
        component:TransationStatusV2Component
      },
      {
        path: '**', redirectTo: 'not-found'
      }
    ]
  },
  {
    path: 'virtual',
    component:ChannelVirtualComponent,
    children: [
      {
        path: '', component: PortalComponent, children: [
          { path: 'payments', component: PaymentsComponent }
        ]
      },
      {
        path: 'afripay', children: [
          {
            path: '', component: AfripayComponent, children: [
              { path: 'wallet', component: WalletComponent },
              { path: 'processing', component: ProcessingComponent }// ,
              // { path: 'confirmation', component: ConfirmationComponent},
              // { path: 'status', component: StatusComponent}
            ]
          }
        ]
      },
      {
        path: 'eft', children: [
          {
            path: '', component: EftComponent, children: [
              { path: 'transaction', component: SecureEftTransactionComponent }
            ]
          }
        ]
      },
      {
        path: 'mobicred', children: [
          {
            path: '', component: MobicredComponent, children: [
              { path: 'login', component: MobicredLoginComponent },
              { path: 'otp', component: MobicredOtpComponent }
            ]
          }
        ]
      },
      {
        path: 'ott_voucher', children: [
          {
            path: '', component: OttVoucherComponent, children: [
              { path: 'input', component: VoucherInputComponent },
              { path: 'processing', component: VoucherProcessingComponent }
            ]
          }
        ]
      },
      {
        path: 'card', children: [
          {
            path: '', component: CardComponent, children: [
              { path: 'add', component: CardAddComponent },
              { path: 'tds', component: TdsComponent },
              { path: 'instalment', component: InstalmentComponent},
              { path: 'confirm-selection/:vPlanId', component: ConfirmSelectionComponent}
            ]
          }
        ]
      },
      {
        path: 'master_pass', children: [
          { path: '', component: MasterPassComponent }
        ]
      },
      {
        path: 'master_pass', children: [
          { path: 'validate', component: ValidateComponent }
        ]
      },
      {
        path: 'switchpay', children: [
          { path: '', component: SwitchpayComponent }
        ]
      },
      {
        path: 'switchpay', children: [
          { path: 'callback', component: SwitchpayCallbackComponent }
        ]
      },
      {
        path: 'zapper', children: [
          { path: '', component: ZapperComponent, children: [] }
        ]
      },
      {
        path: 'click_to_pay', children: [
          {
            path: '', component: ClickToPayComponent, children: [
              { path: 'visa', component: VisaClickToPayComponent }
            ]
          }
        ]
      },
      {
        path: 'adumoeft', children: [
          { path: '', component: AdumoeftComponent }
        ]
      },
      {
        path: 'adumoeft', children: [
          { path: 'callback', component: AdumoeftCallbackComponent }
        ]
      },
      {
        path: 'ozow', children: [
          { path: '', component: OzowComponent }
        ]
      },
      {
        path: 'ozow', children: [
          { path: 'status', component: OzowCallbackComponent }
        ]
      },
      {
        path: 'error',
        component: ErrorHandlingComponent,
      },
      {
        path: '**', redirectTo: 'not-found'
      },
      {
        path: 'not-found', component: NotFoundComponent
      },
      {
        path: 'payments', component: PaymentsComponent
      },
      {
        path: 'error',
        component: ErrorHandlingComponent,
      },
    ]
  },
  {
    path: 'transaction-status',
    children:[{
      path:'',
      component: TransactionStatusComponent
    }],
    component: ChannelVirtualComponent
  },
  {
    path: 'transaction-status/:userCancelled',
    children:[{
      path:'',
      component: TransactionStatusComponent
    }],
    component: ChannelVirtualComponent
  },
  {
    path: 'transaction-status/:eft',
    // /:success/:merchant_reference/:gateway_reference/:transaction_id/:organisation_id/:payment_key/:status=success
    children:[{
      path:'',
      component: TransactionStatusComponent
    }],
    component: ChannelVirtualComponent
  },
  {
    path: 'not-found',
    children:[{
      component: NotFoundComponent,
      path:''
    }],
    component:ChannelVirtualComponent
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'virtual'
  },
  {
    path: 'error',
    children:[{
      path:'',
      component: ErrorHandlingComponent
    }],
    component: ChannelVirtualComponent,
  },
  {
    path: 'payment-page',
    children:[{
      path:'',
      component: ChannelPaymentPageComponent
    }],
    component: ChannelVirtualComponent
  },
  {
    path: '**', redirectTo: 'not-found'
  },

];

@NgModule({
  imports: [
    /*     RouterModule.forRoot(routes, {
          scrollPositionRestoration: 'enabled',
          preloadingStrategy: PreloadAllModules,
        }), */
    RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', preloadingStrategy: QuicklinkStrategy, relativeLinkResolution: 'legacy' })
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
